import React from "react";
import { func, array } from "prop-types";
import { useTranslation } from "@lib/i18n";

import Typography from "@components/shared/Typography";
import RequestButton from "@components/shared/RequestButton";
import { hyphenate } from "@components/shared/utils";

import { useGetFormattedPrice } from "@hooks/useGetFormattedPrice";
import { useVehicleQuantitySelector } from "@redux/reducers/deal";
import { priceAlgorithm } from "@lib/priceAlgorithm";

const ServicesDetail = ({
  onServiceButtonClick,
  selectedServices,
  availableServices,
}) => {
  const { t } = useTranslation();
  const getFormattedPrice = useGetFormattedPrice();
  const quantity = useVehicleQuantitySelector();

  return (
    <div className="flex flex-col gap-4 w-full pb-6 divide-y divide-greyLight">
      {availableServices.map(service => {
        const isServiceSelected = selectedServices.find(
          item => item.id === service.id
        );

        return (
          <div data-id="customize-include" key={service.id}>
            <div className="flex flex-col mb-4">
              <Typography
                className="uppercase font-semibold my-2"
                data-id={`customize-include-item-name-${hyphenate(
                  service.label
                )}`}
              >
                {service.label}
              </Typography>
            </div>
            <div className="flex flex-col justify-between items-center pb-8 relative text-black smallMobile:flex-row">
              <RequestButton
                data-id={`customize-${
                  isServiceSelected ? "remove" : "add"
                }-package`}
                triggerRequestCallback={() => onServiceButtonClick(service)}
                variant={isServiceSelected ? "secondary" : "primary"}
              >
                {isServiceSelected ? t("customize.remove") : t("customize.add")}
              </RequestButton>
              <Typography className="text-4xl uppercase font-semibold">
                {t("mathSymbols.plus")}
                {getFormattedPrice(
                  priceAlgorithm.times(service.netPrice, quantity)
                )}
              </Typography>
            </div>

            <Typography className="text-sm/normal">
              {service.description}
            </Typography>

            <div className="flex flex-col mb-4">
              <Typography
                className="uppercase font-semibold my-2"
                data-id="customize-advantages-heading"
              >
                {t("customize.advantages")}
              </Typography>
              <ul className="p-4 list-disc">
                {service.descriptionAdvantages
                  .split(";")
                  .map((advantage, index) => (
                    <li className="ml-2 text-primaryOrange" key={index}>
                      <Typography className="text-sm/normal">
                        {advantage}
                      </Typography>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        );
      })}
    </div>
  );
};

ServicesDetail.propTypes = {
  onServiceButtonClick: func.isRequired,
  selectedServices: array.isRequired,
  availableServices: array.isRequired,
};

export default ServicesDetail;
